import Loading from "components/Shared/Loading";
import React, { useEffect, useState } from "react";
import { STATUS } from "../../constants";
import { findIndex, get, orderBy } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { getErrorResults } from "./errorResultSlice";
import { getAiErrorResults } from "./aiErrorResultSlice";

import ErrorList from "./components/ErrorList";
import ErrorPreviewComponent from "./components/ErrorPreviewComponent";
import ClientUploadComponent from "./components/ClientUploadComponent";
import SpecialistFileUpload from "pages/shared/SpecialistFileUpload";
import FilesUploader from "components/FilesUploader";
import AiFilesUploader from "components/AiFilesUploader";

const ErrorResultsInbox = ({ aiOcr = false }) => {
  const dispatch = useDispatch();
  const { status: statusOld, data: resultsOld = [] } = useSelector(({ errorResults }) => errorResults);
  const { status: statusAI, data: resultsAI = [] } = useSelector(({ aiErrorResults }) => aiErrorResults);
  const [status, setStatus] = useState(aiOcr ? statusAI : statusOld);
  const [results, setResults] = useState(aiOcr ? resultsAI : resultsOld);
  useEffect(() => {
    setStatus(aiOcr ? statusAI : statusOld);
  }, [aiOcr, statusAI, statusOld]);
  useEffect(() => {
    setResults(aiOcr ? resultsAI : resultsOld);
  }, [aiOcr, resultsAI, resultsOld]);
  const specialistProfiles = useSelector((state) =>
    orderBy(get(state, "app.specialistProfiles", []), ["firstName", "lastName"], ["asc", "asc"])
  );

  const [activeResult, setActiveResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const onUploadTestResultFinished = async () => {
    aiOcr ? dispatch(getAiErrorResults()) : dispatch(getErrorResults());
  };

  useEffect(() => {
    if ([STATUS.DEFAULT].includes(status)) {
      aiOcr ? dispatch(getAiErrorResults()) : dispatch(getErrorResults());
    }
    setIsLoading(STATUS.LOADING === status);
  }, [dispatch, status, aiOcr]);

  useEffect(() => {
    if (!activeResult) {
      setActiveResult(results[0] || null);
    } else {
      const activeIndex = findIndex(results, { id: activeResult.id });
      if (activeIndex === -1) {
        setActiveResult(results[0] || null);
      }
    }
  }, [activeResult, results]);

  const result = activeResult || results[0] || null;

  return isLoading ? (
    <Loading />
  ) : (
    <>
      {aiOcr ? (
        <AiFilesUploader type="result" buttonTitle="Upload Results" />
      ) : (
        <FilesUploader folder="result-upload-working" buttonTitle="Upload Results" />
      )}
      <div className="columns">
        <div className="column is-3">
          <p className="menu-label">ABNORMAL RESULTS</p>
          <ErrorList
            results={results}
            activeResult={activeResult || results[0] || null}
            onSelectResult={setActiveResult}
          />
        </div>
        {results.length > 0 ? (
          <>
            <div className="column is-6">
              <p className="menu-label">FILE</p>
              <ErrorPreviewComponent key={result?.fileName} fileName={result?.fileName} aiOcr={aiOcr} />
            </div>
            <div className="column is-3">
              <p className="menu-label">CLIENT</p>
              <ClientUploadComponent file={result} onFinish={onUploadTestResultFinished} aiOcr={aiOcr} />
              <div className="columns is-vcentered">
                <div className="column is-5">
                  <hr />
                </div>
                <div className="column is-2 is-size-7 has-text-centered has-text-weight-bold">OR</div>
                <div className="column is-5">
                  <hr />
                </div>
              </div>
              <SpecialistFileUpload
                file={result}
                specialistProfiles={specialistProfiles}
                fromReferralInbox={false}
                aiOcr={aiOcr}
              />
            </div>
          </>
        ) : (
          <div>No Data</div>
        )}
      </div>
    </>
  );
};

export default ErrorResultsInbox;
